var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Grid, styled, Typography } from "@mui/material";
var VTDragButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        background: "#444",
        borderRadius: "10px",
    });
});
export default function VTDragMedia(_a) {
    var _b = _a.title, title = _b === void 0 ? "Drag and drop your first scene" : _b, _c = _a.size, size = _c === void 0 ? 150 : _c, image = _a.image, onClick = _a.onClick, sx = _a.sx;
    return (_jsxs(Grid, __assign({ container: true, sx: __assign({ backgroundColor: "#3A3B3D", width: 227 }, sx) }, { children: [_jsx(VTDragButton //change VTButton
            , __assign({ onClick: function () { return onClick && onClick(); }, sx: {
                    backgroundColor: "black",
                    color: "purple",
                    padding: "20px 80px",
                    marginLeft: 1,
                } }, { children: _jsx("img", __assign({ style: { width: "60px", height: "60xp" }, src: "https://upload.wikimedia.org/wikipedia/commons/b/b0/NewTux.svg" }, { children: image })) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Typography, __assign({ sx: { textAlign: "center", color: "white" } }, { children: title })) }))] })));
}
